import axios from 'axios';

class UserService {
  constructor() {
    this.API_URL = process.env.REACT_APP_API_URL_V;
    this.apiClient = axios.create({
      baseURL: this.API_URL,
      headers: {
        'Access-Control-Allow-Origin': '*',
      },
    });

    this.apiClient.interceptors.request.use(config => {
      //   const token = JSON.parse(localStorage.getItem('loginInfonetApp'))?.token || '';
      //   console.log(token)
      const token = localStorage.getItem("accesstoken");
      config.headers['x-auth-token'] = token;
      return config;
    }, error => {
      return Promise.reject(error);
    });
  }

  async getUsers(data) {
    const response = await this.apiClient.post('/admins/users/list', data);
    return response.data.data;
  }
  async getAllUsers(data) {
    const response = await this.apiClient.post('/admins/listuser', data);
    return response.data.data;
  }
  async getUsersByrole(data) {
    const response = await this.apiClient.post('/admins/usersbyrole', data);
    return response.data.data;
  }
  async getRoles(data) {
    const response = await this.apiClient.post('/admins/roles/list', data);
    return response.data.data;
  }

  async addUser(user) {
    const response = await this.apiClient.post('/admins/users', user);
    return response.data;
  }

  async updateUser(id, user) {
    const response = await this.apiClient.put(`/admins/users/${id}`, user);
    return response.data;
  }

  async updatePassword(id, data) {
    console.log(id, data);
    const response = await this.apiClient.put(`/auth/updatepassword/${id}`, data);
    return response.data;
  }

  async deleteUser(id) {
    const response = await this.apiClient.delete(`/admins/users/${id}`);
    return response.data;
  }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new UserService();
